import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unavailable-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleMessageCard = _resolveComponent("SingleMessageCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SingleMessageCard, {
      trailerNumber: _ctx.trailerNumber,
      trailerStatusSubtitle: _ctx.trailerStatusSubtitle,
      trailerStatusTitle: _ctx.trailerStatusTitle,
      detailsDescription: _ctx.detailsDescription,
      onReject: _ctx.goBackToManualEntry
    }, null, 8, ["trailerNumber", "trailerStatusSubtitle", "trailerStatusTitle", "detailsDescription", "onReject"])
  ]))
}